import React from 'react';
import { Form, Input, Select, Typography } from 'antd';
import type { FormInstance } from 'antd';

const { Title, Text } = Typography;

export interface UserFormValues {
  email: string;
  firstName: string;
  lastName: string;
  roleIds?: string[];
  customerSegmentIds?: string[];
}

export interface UserFormProps {
  form: FormInstance<UserFormValues>;
  onFinish: (values: UserFormValues) => void;
  saving?: boolean;
  roleOptions?: { id: string; name: string }[];
  segmentOptions?: { id: string; title: string }[];
}

const UserForm: React.FC<UserFormProps> = ({ form, onFinish, roleOptions = [], segmentOptions = [] }) => {
  const handleFinish = (values: UserFormValues) => {
    onFinish(values);
  };

  return (
    <Form<UserFormValues> form={form} layout="vertical" onFinish={handleFinish}>
      <div className="cp-form-section">
        <Title level={5} style={{ marginTop: 0 }}>
          Basic information
        </Title>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true }, { type: 'email' }]}
        >
          <Input placeholder="user@example.com" />
        </Form.Item>
        <Form.Item
          label="First name"
          name="firstName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Last name"
          name="lastName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Text type="secondary">
          An invite email with a set-password link will be sent automatically.
        </Text>
        {roleOptions.length > 0 && (
          <Form.Item label="Roles" name="roleIds" style={{ marginTop: 16 }}>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select roles"
              options={roleOptions.map((r) => ({ value: r.id, label: r.name }))}
            />
          </Form.Item>
        )}
        {segmentOptions.length > 0 && (
          <Form.Item label="Customer segments" name="customerSegmentIds">
            <Select
              mode="multiple"
              allowClear
              placeholder="None = org-wide visibility"
              options={segmentOptions.map((s) => ({ value: s.id, label: s.title }))}
            />
          </Form.Item>
        )}
      </div>
    </Form>
  );
};

export default UserForm;
